// const Botservice = process.env.REACT_APP_BOT_URL as string
const Botservice = "https://bot.dentagenix.com/"

export default Botservice;
